<template>
  <el-dialog
    title="发放权益卡"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="500px"
    @close="handleClose"
  >
    <el-form ref="dataForm" label-width="100px" v-loading="formLoading">
      <!--多选-->
      <el-form-item label="会员用户">
        <el-select
          v-model="memberIds"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="支持手机号与昵称模糊搜索"
          :remote-method="loadMemberUsers"
          :loading="loading"
        >
          <el-option
            v-for="item in memberUsers"
            :key="item.id"
            :label="item.nickname + '（' + item.phoneNo + '）'"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!--button-->
      <el-form-item>
        <el-button type="primary" @click="handleGrant">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </el-form-item>
      <!--/button-->
    </el-form>
  </el-dialog>
</template>
<script>
import { loadSubscriberListApi } from "@/api/subscriber";
import { bizPrivilegeCardGrant } from "@/api/privilege";
export default {
  name: "GrantPrivilegeCard",
  data() {
    return {
      formLoading: false,
      loading: false,
      visible: false,
      memberUsers: [],
      memberIds: [],
      privilegeCardInfo: {}
    };
  },
  methods: {
    open(row) {
      this.visible = true;
      this.privilegeCardInfo = row;
      this.loadMemberUsers();
    },
    handleClose() {
      this.visible = false;
      this.$emit("close");
      this.memberUsers = [];
      this.memberIds = [];
    },
    loadMemberUsers(query) {
      let params = {};
      if (query !== "") {
        params.keyword = query;
      }
      this.loading = true;
      loadSubscriberListApi(params)
        .then(res => {
          if (res.data.status == 100) {
            this.memberUsers = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleGrant() {
      if (this.memberIds.length == 0) {
        this.$message({
          message: "请选择会员",
          type: "error"
        });
        return;
      }
      // 二次确认
      this.$confirm("是否确定发放优惠券?", "提示", {
        type: "warning"
      }).then(() => {
        this.grantPrivilegeCard();
      });
    },
    grantPrivilegeCard() {
      if (
        this.memberIds.length == 0 ||
        this.privilegeCardInfo == null ||
        this.privilegeCardInfo.id == null
      ) {
        return;
      }
      this.formLoading = true;
      bizPrivilegeCardGrant(this.privilegeCardInfo.id, this.memberIds)
        .then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.handleClose();
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// grant.vue?a1e26cca